import { render, staticRenderFns } from "./UserRebateLogs.vue?vue&type=template&id=167549be&"
import script from "./UserRebateLogs.vue?vue&type=script&lang=js&"
export * from "./UserRebateLogs.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports